module.exports = __webpack_public_path__ + "static/media/customers-served.3fe509f8.png";